import util from '../util'

let controller = 'LimiteOperadorAdicional'

export default Object.assign({}, util.GetCrud(controller, ['post', 'put', 'get', 'getall', 'persist', 'delete']), {
  HistoricoLimiteOperadorAdicional: function (dto) {
    return util.Axios.GetAll(controller + '/LogsLimiteOperadorAdicional', dto)
  }
})
